import { validateEmail, verifyEmailDomainExists } from "@/utils/emailValidation";

export default {
  data() {
    return {
      emailDomainStatus: "idle",
      emailDomainCheckToken: 0,
      emailDomainCheckTimer: null,
    };
  },
  beforeDestroy() {
    this.clearEmailDomainCheckTimer();
  },
  methods: {
    getEmailFieldValue() {
      return this.email;
    },
    setEmailFieldValue(value) {
      this.email = value;
    },
    clearEmailDomainCheckTimer() {
      if (this.emailDomainCheckTimer) {
        clearTimeout(this.emailDomainCheckTimer);
        this.emailDomainCheckTimer = null;
      }
    },
    clearEmailFieldError() {
      if (this.errors && this.errors.email) {
        this.$delete(this.errors, "email");
      }
    },
    setEmailFieldError(message) {
      if (!this.errors || Array.isArray(this.errors)) {
        this.errors = {};
      }
      this.$set(this.errors, "email", [message]);
    },
    onEmailFieldInput() {
      this.emailDomainStatus = "idle";
      this.clearEmailFieldError();
      this.scheduleEmailDomainCheck();
    },
    onEmailFieldBlur() {
      if (String(this.getEmailFieldValue() || "").trim()) {
        this.runEmailDomainCheck();
      }
    },
    scheduleEmailDomainCheck() {
      this.clearEmailDomainCheckTimer();
      this.emailDomainCheckTimer = setTimeout(() => {
        this.runEmailDomainCheck();
      }, 600);
    },
    async runEmailDomainCheck() {
      const emailResult = validateEmail(this.getEmailFieldValue(), {
        required: false,
      });
      if (!emailResult.valid || !emailResult.email) {
        this.emailDomainStatus = "idle";
        return;
      }

      const domain = emailResult.email.split("@")[1];
      const token = ++this.emailDomainCheckToken;
      this.emailDomainStatus = "checking";

      const domainResult = await verifyEmailDomainExists(domain);
      if (token !== this.emailDomainCheckToken) {
        return;
      }

      if (domainResult.exists === true) {
        this.emailDomainStatus = "valid";
        this.clearEmailFieldError();
        return;
      }

      if (domainResult.exists === false) {
        this.emailDomainStatus = "invalid";
        this.setEmailFieldError(domainResult.message);
        return;
      }

      this.emailDomainStatus = "unknown";
    },
    async waitForEmailDomainCheck() {
      const started = Date.now();
      while (this.emailDomainStatus === "checking") {
        if (Date.now() - started > 10000) {
          break;
        }
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    },
    async validateEmailFieldComplete({
      required = true,
      verifyDomain = true,
    } = {}) {
      const syntax = validateEmail(this.getEmailFieldValue(), { required });
      if (!syntax.valid) {
        this.setEmailFieldError(syntax.message);
        return { valid: false, email: syntax.email, message: syntax.message };
      }

      if (!syntax.email) {
        this.clearEmailFieldError();
        return { valid: true, email: "", message: "" };
      }

      this.setEmailFieldValue(syntax.email);

      if (!verifyDomain) {
        this.clearEmailFieldError();
        return { valid: true, email: syntax.email, message: "" };
      }

      if (this.emailDomainStatus === "idle") {
        await this.runEmailDomainCheck();
      } else {
        await this.waitForEmailDomainCheck();
      }

      if (this.emailDomainStatus === "invalid") {
        const message =
          (this.errors &&
            this.errors.email &&
            this.errors.email[0]) ||
          "Please enter a valid email address.";
        return { valid: false, email: syntax.email, message };
      }

      if (this.emailDomainStatus === "idle") {
        const domainResult = await verifyEmailDomainExists(
          syntax.email.split("@")[1]
        );
        if (domainResult.exists === false) {
          this.emailDomainStatus = "invalid";
          this.setEmailFieldError(domainResult.message);
          return {
            valid: false,
            email: syntax.email,
            message: domainResult.message,
          };
        }
        this.emailDomainStatus = domainResult.exists ? "valid" : "unknown";
      }

      this.clearEmailFieldError();
      return { valid: true, email: syntax.email, message: "" };
    },
  },
};
